/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PharmacyCounselorAcceptCodeLabel,
  PharmacyCounselorAcceptCodeLabelFromJSON,
  PharmacyCounselorAcceptCodeLabelFromJSONTyped,
  PharmacyCounselorAcceptCodeLabelToJSON,
} from "./";

export const PharmacyCounselorPublicCrowdStatusTypename = "PharmacyCounselorPublicCrowdStatus" as const;

/**
 *
 * @export
 * @interface PharmacyCounselorPublicCrowdStatus
 */
export interface PharmacyCounselorPublicCrowdStatus {
  /**
   *
   * @type {Array<PharmacyCounselorAcceptCodeLabel>}
   * @memberof PharmacyCounselorPublicCrowdStatus
   */
  acceptCodeLabels?: Array<PharmacyCounselorAcceptCodeLabel>;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyCounselorPublicCrowdStatus
   */
  enableAcceptCodeMultiLine?: boolean;
  /**
   *
   * @type {number}
   * @memberof PharmacyCounselorPublicCrowdStatus
   */
  pharmacyId?: number;
  /**
   *
   * @type {number}
   * @memberof PharmacyCounselorPublicCrowdStatus
   */
  quantity?: number;
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorPublicCrowdStatus
   */
  unitType: PharmacyCounselorPublicCrowdStatusUnitTypeEnum;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyCounselorPublicCrowdStatus
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PharmacyCounselorPublicCrowdStatusUnitTypeEnum {
  People = "people",
  Minute = "minute",
}

export function PharmacyCounselorPublicCrowdStatusFromJSON(json: any): PharmacyCounselorPublicCrowdStatus {
  return PharmacyCounselorPublicCrowdStatusFromJSONTyped(json, false);
}

export function PharmacyCounselorPublicCrowdStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyCounselorPublicCrowdStatus {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyCounselorPublicCrowdStatusTypename,

    acceptCodeLabels: !exists(json, "accept_code_labels")
      ? undefined
      : (json["accept_code_labels"] as Array<any>).map(PharmacyCounselorAcceptCodeLabelFromJSON),
    enableAcceptCodeMultiLine: !exists(json, "enable_accept_code_multi_line")
      ? undefined
      : json["enable_accept_code_multi_line"],
    pharmacyId: !exists(json, "pharmacy_id") ? undefined : json["pharmacy_id"],
    quantity: !exists(json, "quantity") ? undefined : json["quantity"],
    unitType: json["unit_type"],
  };
}

export function PharmacyCounselorPublicCrowdStatusToJSON(object?: PharmacyCounselorPublicCrowdStatus | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    accept_code_labels:
      value.acceptCodeLabels === undefined
        ? undefined
        : (value.acceptCodeLabels as Array<any>).map(PharmacyCounselorAcceptCodeLabelToJSON),
    enable_accept_code_multi_line: value.enableAcceptCodeMultiLine,
    pharmacy_id: value.pharmacyId,
    quantity: value.quantity,
    unit_type: value.unitType,
  };
}
